import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./loginform.css";
import SglContext from "../SglContext";


export default function ConfirmEmail() {
  const [loading, setLoading] = useState(true);
  const [email_confirmed, set_email_confirmed] = useState(false);
  const [company_name, setCompanyName] = useState("");
  const [error_message, set_error_message] = useState("");
  const Sgl = useContext(SglContext)

  //API END POINTS
  const sgl_webservice_confirm_email_verification =
  Sgl.sglApiUrl + "/iphone.php/webservice/ConfirmEmailChange";

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  useEffect(() => {
    axios
      .all([
        axios.get(sgl_webservice_confirm_email_verification, {
          params: {
            customer_id: Sgl.company_id,
            cec_key: getQueryVariable("cec_key"),
            cec_id: getQueryVariable("cec_id"),
          },
        }),
      ])
      .then(
        axios.spread((response) => {

          setLoading(false);
          setCompanyName(response.data.company_name);
          set_email_confirmed(response.data.success);
          set_error_message(response.data.error);
        })
      );
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div id='sgl-content-wrapper loginformcss'>
      <div className='sgl-plugin'>
        <div id='sgl-plugin-email-success-message'>
          {(() => {
            if (email_confirmed) {
              return (
                <div>
                  <h1>Email Address Updated!</h1>
                  <p>
                    Your email address has been updated successfully for{" "}
                    {company_name}!
                  </p>
                </div>
              );
            } else {
              return (
                <div>
                  <h1>Error!</h1>
                  <p>{error_message}</p>
                </div>
              );
            }
          })()}
        </div>
      </div>
    </div>
  );
}
